import { render } from "./AppMenu.vue?vue&type=template&id=c0210a4e&scoped=true"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-c0210a4e"

export default script